import { Output, EventEmitter, Directive } from "@angular/core";

/**
 * This class is used to host dialog content. The parent form (in the hosting dialog)
 * wants to keep the state of the child component. The isValid event emitter will be fired
 * when the child components needs to adjust its validity state.
 */
@Directive()
export class DialogChild {
    /**
     * Fires when the validity of the child has changed.
     */
    @Output() isValid = new EventEmitter<boolean>();

    /**
     * Fires when the allow close state of the child has changed.
     */
    @Output() allowClose = new EventEmitter<boolean>();

    /**
     * Fires when the primary dialog event should be emitted
     */
    @Output() onPrimary = new EventEmitter();

    /**
     * Fires when the secondary dialog event should be emitted
     */
    @Output() onSecondary = new EventEmitter();

    /**
     * Data parameters set by the host (pass through from the caller opening the dialog).
     * Depending on implementers of DialogChild, this object is emitted to the Observer stream as returned data.
     */
    data: any;

    /**
     * Emit the validity event
     * 
     * @param isValid true if component is in a valid state, otherwise false
     */
    protected raiseIsValid(isValid: boolean) {
        this.isValid.emit(isValid);
    }

    /**
     * Emit the allow close event
     * 
     * @param allowClose true if the host dialog is allowed to close, otherwise false
     */
    protected raiseAllowClose(allowClose: boolean) {
        this.allowClose.emit(allowClose);
    }

    /**
     * Emit the primary event
     */
    protected raiseOnPrimary() {
        this.onPrimary.emit();
    }

    /**
     * Emit the secondary event
     */
    protected raiseOnSecondary() {
        this.onSecondary.emit();
    }
}
